import React from 'react';
import styled from 'styled-components';
import { CardShell, asText } from './shared';

export interface TimelineSpec {
  tipo: 'linha_do_tempo';
  titulo?: string;
  eventos?: { data?: unknown; titulo?: unknown; descricao?: unknown }[];
  fonte?: string;
}

/** Cronologia: marcador e data à esquerda, um fio liga os eventos. */
export function Timeline({ spec }: { spec: TimelineSpec }) {
  const events = (spec.eventos || []).filter(Boolean);
  if (!events.length) return null;
  return (
    <CardShell title={spec.titulo} source={spec.fonte} label="linha_do_tempo">
      <TimelineList>
        {events.map((ev, i) => (
          <TimelineItem key={i} $last={i === events.length - 1}>
            <Dot />
            <div>
              {ev.data !== undefined && <When>{asText(ev.data)}</When>}
              <ItemTitle>{asText(ev.titulo)}</ItemTitle>
              {ev.descricao !== undefined && <Desc>{asText(ev.descricao)}</Desc>}
            </div>
          </TimelineItem>
        ))}
      </TimelineList>
    </CardShell>
  );
}

const accent = ({ theme }: any) => theme.prompt_accent_color || '#1a3c34';
const line = ({ theme }: any) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.14)' : 'rgba(0,0,0,0.12)');

const TimelineList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const TimelineItem = styled.li<{ $last: boolean }>`
  position: relative;
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 10px;
  padding-bottom: ${({ $last }) => ($last ? 0 : '14px')};
  &::before {
    content: '';
    display: ${({ $last }) => ($last ? 'none' : 'block')};
    position: absolute;
    left: 8px;
    top: 14px;
    bottom: -2px;
    width: 2px;
    background: ${line};
  }
`;

const Dot = styled.span`
  width: 10px;
  height: 10px;
  margin: 4px 0 0 4px;
  border-radius: 50%;
  background: ${accent};
  box-shadow: 0 0 0 3px ${({ theme }) => (theme.mode === 'dark' ? 'rgba(93,168,138,0.2)' : 'rgba(26,60,52,0.12)')};
`;

const When = styled.div`
  font-size: 0.74rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${accent};
  margin-bottom: 1px;
`;

const ItemTitle = styled.div`
  font-weight: 600;
  font-size: 0.88rem;
  line-height: 1.45;
`;

const Desc = styled.div`
  font-size: 0.84rem;
  line-height: 1.5;
  opacity: 0.8;
  margin-top: 2px;
`;

